import { render, staticRenderFns } from "./organism.modal.startOver.vue?vue&type=template&id=7b298256"
import script from "./organism.modal.startOver.vue?vue&type=script&lang=ts"
export * from "./organism.modal.startOver.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports